export default "__VITE_ASSET__BJnfX$xB__"